import { put, call, takeLatest } from 'redux-saga/effects';
import { removeDriverAccess } from '~/common/redux/api';
import * as actions from '../actions';
import { REMOVE_DRIVER_ACCESS_REQUEST } from '../types';

export function* removeDriverAccessSaga(action) {
  try {
    yield put(actions.addLoader(REMOVE_DRIVER_ACCESS_REQUEST));
    const { ownerUid, vin } = action.payload;
    const {
      data: { success },
    } = yield call(removeDriverAccess, { ownerUid, vin });

    if (!success) {
      yield put(actions.removeDriverAccessFailure());
    } else {
      yield put(actions.removeDriverAccessSuccess());
    }
  } catch (e) {
    yield put(actions.removeDriverAccessFailure());
  }
  yield put(actions.removeLoader(REMOVE_DRIVER_ACCESS_REQUEST));
}

const driverAccessSaga = [takeLatest(REMOVE_DRIVER_ACCESS_REQUEST, removeDriverAccessSaga)];

export default driverAccessSaga;
